<template>
  <div class="tool right flex flex-row scale-tool items-center">
    <p class="scale-title">Scale</p>
    <slider
      class="flex-grow"
      width="auto"
      height="2px"
      v-model="value"
      :min="20"
      :max="100"
      :interval="20"
      @change="setScale"
      :tooltip-formatter="'{value}%'"
      tooltip="always"
      :mark="true"
    ></slider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { mapActions } from 'vuex';

export default {
  name: 'ScaleTool',
  components: { slider: VueSlider },

  data() {
    return {
      value: 100,
    };
  },

  mounted() {
    this.value = this.$store.state.scale;
  },

  methods: {
    ...mapActions({
      setScale: 'setScale',
    }),
    scale(value) {
      this.setScale(value);
    },
  },
};
</script>

<style lang="scss">
.tool {
  .scale-title {
    margin-right: 10px;
  }

  .vue-slider-dot-handle-focus {
    box-shadow: 0.5px 0.5px 2px 1px theme('colors.dm') !important;
  }

  .vue-slider {
    .vue-slider-dot-handle {
      width: 8px;
      height: 20px;
      margin-top: -3px;
      border: 2px solid white;
      border-radius: 5px !important;
      background: transparent !important;
      top: -11.5px !important;
      z-index: unset !important;
    }

    .vue-slider-dot-tooltip-top {
      top: -5px !important;
    }

    .vue-slider-dot-tooltip-inner {
      font-size: 12px;
      white-space: nowrap;
      padding: 2px 5px;
      min-width: 20px;
      text-align: center;
      color: #fff;
      border-radius: 5px;
      border-color: transparent;
      background-color: transparent;
      box-sizing: content-box;
    }

    .vue-slider-process {
      background: theme('colors.dm');
    }
  }
}
</style>
